import JunkValues from "../../../components/junk-values/junk-values";
import Page from "../../page";

const JunkValuesPage = () => {
  return (
    <Page>
      <JunkValues />
    </Page>
  );
};

export default JunkValuesPage;
